import styled from 'styled-components';

const Container = styled.button`
  width: 320px;
  height: 80px;

  background: #1f6f8b;
  border: 3px solid #E6D5B8;
  border-radius: 10px;
  
  color: #E6D5B8;
  font-size: 24px;

`;

export default Container;